import React from 'react';
import '../styles/FourOptions.css';

function FourOptions({ sectionTitle, sectionDescription, options }) {
  return (
	<div className="four-options">
	  {/* Section Title */}
	  <h2 className="four-options-header">{sectionTitle}</h2>
	  
	  {/* Section Description */}
	  <p className="four-options-description">{sectionDescription}</p>
	  
	  {/* Options Grid */}
	  <div className="four-options-grid">
		{options.map((option, index) => (
		  <div key={index} className="four-options-card">
			<h3 className="option-number">{`0${index + 1}`}</h3>
			<h4 className="option-title">{option.title}</h4>
			<p className="option-body">{option.body}</p>
		  </div>
		))}
	  </div>
	</div>
  );
}

export default FourOptions;